import React, { memo } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'

function Tran_stock_modal(props) {
    const handleCloseModal = () => {
        props.setShowStockModal(false);
    }
    return (
        <div>
            <Modal show={props.showStockModal} centered onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Stock Available</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Currency : <b>{props.stockObj.isd}</b>
                        </Col>
                        <Col>
                            Deno : <b>{props.stockObj.deno}</b>
                        </Col>
                        <Col>
                            Stock : <b>{props.stockObj.quantity}</b>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default memo(Tran_stock_modal)
